<template>
  <div>
    <div class="dialog-input-item" v-if="remarkId == 0">
      <label>备注类型</label>
      <el-select v-model="type" placeholder="Select" class="select-item">
        <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="modal-area">
      <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 10 }" :maxlength="100" placeholder="100字以内" v-model="content" style="margin-bottom: 24px;"></el-input>
    </div>
    <div class="customize-footer" style="text-align: center">
      <el-button @click="cancel">返 回</el-button>
      <el-button type="primary"  @click="submit" v-loading="submitLoading">提 交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from '../../api/api';
import { addUserRemark } from '../../api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      content: this.value.content?this.value.content:'',
      submitLoading: false,
      id: this.value.id,
      type: this.value.type?this.value.type:0,
      typeArray: [
        {label: '常规备注', value: 0},
        {label: '预约备注', value: 1},
        {label: '充值备注', value: 3},
        {label: '回访备注', value: 4},
      ],
      remarkId: this.value.remarkId?this.value.remarkId:0,
      sourceType: this.value.sourceType?this.value.sourceType:0,
      sourceId: this.value.sourceId?this.value.sourceId:0,
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },

    submit() {
      if(!this.content) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '内容不能为空',
          type: 'warning'
        })
        return;
      }
      let param = {
        'id': this.id,
        'content': this.content,
        // 'type': this.type,
        'remarkId': this.remarkId
      }
      // if(this.remarkId == 0) {
      //   param.type = this.type
      // }else {
      //   param.sourceType = this.sourceType
      //   param.sourceId = this.sourceId
      // }
      param.type = this.type
      param.sourceType = this.sourceType
      param.sourceId = this.sourceId
      postFormData(addUserRemark, param).then((data) => {
        let {code,msg} = data;
        if(code == 200){
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm');
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(function(response){
            this.submitLoading = false;
          })
    }
  },
  mounted() {
    if(this.content) {
      if(this.content.indexOf('预约备注') > -1 || this.content.indexOf('充值备注') > -1 || this.content.indexOf('回访备注') > -1) {
        this.content = this.content.slice(5)
      }
    }
  }
}
</script>

<style>

</style>
